// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import './polyfill'
// import cssVars from 'css-vars-ponyfill'
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'
import VueResource from 'vue-resource'
import i18n from '@/config/i18n';
import axios from 'axios'
import VueQuillEditor from 'vue-quill-editor'
// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import InfiniteScroll from "vue-infinite-scroll";
import keycloak from "./utils/keycloak";

Vue.use(InfiniteScroll);
Vue.use(BootstrapVue);
Vue.use(VueResource);
Vue.use(i18n);
Vue.use(axios);
Vue.use(VueQuillEditor);

Vue.http.options.root = process.env.VUE_APP_API_BASE_URL;

// TODO Rimuovere Vue-Resource e usare solo il service layer
Vue.http.interceptors.push((request, next) => {
  request.headers.set('Authorization', 'Bearer ' + keycloak.token)
  next()
})

keycloak
  .init({
    onLoad: "login-required",
    redirectUri: window.location.origin + "/#/postAuth"
  })
  .then(async () => {

    console.log("Current user has roles: " + keycloak.tokenParsed.realm_access.roles)
    const hasAdminRole = keycloak.tokenParsed.realm_access.roles.includes("ADMIN");

    // Solo gli utenti con ruolo ADMIN possono accedere
    if (!hasAdminRole) {
      console.log("Authenticated user has invalid role to access! Executing logout")
      await keycloak.logout({redirectUri: window.location.origin + "/#/postAuth"});
    }

    new Vue({
      i18n,
      el: '#app',
      router,
      template: '<App/>',
      components: {
        App
      }
    });
  });

